import { Stack, Typography } from "@mui/material";
import { ChipProps } from "./types";

const Chip = ({ label, color, bgcolor }: ChipProps) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      paddingY={0.5}
      paddingX={1}
      sx={{ bgcolor: bgcolor, borderRadius: 5, display: "inline-flex" }}
    >
      <Typography variant="smallText" sx={{ color: color }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default Chip;
